/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Dispatches PaymentModal step content components by step number and payment method.
 * @module modals/PaymentModal/PaymentModalStepRenderer
 */

import PaymentModalRegistrationStep from "./steps/PaymentModalRegistrationStep.jsx";
import PaymentModalMethodStep from "./steps/PaymentModalMethodStep.jsx";
import PaymentModalCashConfirmStep from "./steps/PaymentModalCashConfirmStep.jsx";
import PaymentModalCardConfirmStep from "./steps/PaymentModalCardConfirmStep.jsx";
import PaymentModalSuccessStep from "./steps/PaymentModalSuccessStep.jsx";
import PaymentModalErrorStep from "./steps/PaymentModalErrorStep.jsx";

const PaymentModalStepRenderer = ({
  stepNumber,
  paymentMethod,
  paymentStatus,
  registrationStepProps,
  methodStepProps,
  cashConfirmStepProps,
  cardConfirmStepProps,
  successStepProps,
  errorStepProps,
}) => (
  <>
    {stepNumber === 1 && (
      <PaymentModalRegistrationStep {...registrationStepProps} />
    )}
    {stepNumber === 2 && <PaymentModalMethodStep {...methodStepProps} />}
    {stepNumber === 3 && paymentMethod === "cash" && (
      <PaymentModalCashConfirmStep {...cashConfirmStepProps} />
    )}
    {stepNumber === 3 && paymentMethod === "card" && (
      <PaymentModalCardConfirmStep {...cardConfirmStepProps} />
    )}
    {stepNumber === 4 &&
      paymentMethod === "card" &&
      paymentStatus === "PAYMENT_SUCCESS" && (
        <PaymentModalSuccessStep {...successStepProps} />
      )}
    {stepNumber === 4 &&
      paymentMethod === "card" &&
      paymentStatus === "PAYMENT_ERROR" && (
        <PaymentModalErrorStep {...errorStepProps} />
      )}
  </>
);

export default PaymentModalStepRenderer;
